import { render, staticRenderFns } from "./purchasereceipts.vue?vue&type=template&id=00ec0455&"
import script from "./purchasereceipts.vue?vue&type=script&lang=js&"
export * from "./purchasereceipts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports